var React = require('react');

function LocationOutline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Location"),React.createElement("path",{"d":"M256 48c-79.5 0-144 61.39-144 137 0 87 96 224.87 131.25 272.49a15.77 15.77 0 0025.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137z","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","key":1}),React.createElement("circle",{"cx":"256","cy":"192","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","key":2})]);
}

LocationOutline.defaultProps = {"className":"ionicon","viewBox":"0 0 512 512"};

module.exports = LocationOutline;

LocationOutline.default = LocationOutline;
